<template>
    <div :class="['techDim2',getPlatformClass]">        

         <div :class="['dimProcCont2', isImgFadeout === true ? 'imgFadeout' : '']">
          <img class="dimItemImg" :src="infoImg" />
        </div>         

        <div :class="['infPlatformBarContainer',plaformIndex>-1 ? 'mounted':'mounted']">
          <platformbar 
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "3"
            skinMode = "light"
            @platform-change="onPlatformChange">
          </platformbar>
        </div>

    </div>
</template>


<script>

import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";
import platformbar from "@/views/com/platformbar.vue";
import splitter from "@/views/com/splitter.vue";

export default {
    name: "techDim2",
    components:{platformbar,splitter},
    props: {
        compData:[],
        sectionType:String,
        sectionIndex:Number,
        visible:Boolean,
        sectionDataIndex:Number,
        isNavOpen: Boolean
        //componentData:Object
    },
    data()
    {
        return {
            componentData:[],
            componentImages:[],
            plaformIndex:0,
            infoImg:'',
            isImgFadeout:true
        }
    },
    mounted()
    {
      //this.componentData = this.getSiteTechTabData();
      //this.componentImages = this.componentData.files.filter(x => x.file_url.indexOf(".png")>0);
      //this.infoImg = this.getImgByIndex(this.plaformIndex);
      this.isImgFadeout = false;

      var vm=this;
      setTimeout(() => {
        vm.$forceUpdate();  
      }, 1000);

    },

    watch: {
    },
    methods:
    {
      getSiteTechTabData()
      {
        var pageSections = this.pageLayoutData.children[0].children;        
        var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
        var targetNodes = techTabsSection[0].children[0].children;
        var targetNode = targetNodes[this.sectionIndex];//.filter(x => x.template == this.sectionType)[0];
        return targetNode;
      },
      getImgByIndex(plaformIndex)
      {
          //return "http://mis-implants.com/upload"+this.componentImages[plaformIndex].file_url;//file_url
          //return "https://mis-implants.com/upload"+this.componentData.files[plaformIndex].file_url;//file_url
      },
      onPlatformChange(plaformIndex)
      {
        var vm = this;        
        var pageSections = this.pageLayoutData.children[0].children;        
        var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
        var targetNodes = techTabsSection[0].children[0].children;
        var targetNode = targetNodes[this.sectionIndex];//.filter(x => x.template == this.sectionType)[0];
        var mediaImages = targetNode.files.filter(x => x.file_url.indexOf(".png")>0);

        vm.isImgFadeout = true;        
        setTimeout(() => 
        {
          vm.plaformIndex = plaformIndex;
          vm.infoImg = "https://mis-implants.com/upload"+mediaImages[plaformIndex].file_url;// vm.getImgByIndex(plaformIndex);
        }, 500);
        setTimeout(() => {
          vm.isImgFadeout = false;
        }, 1100);
        
      },
      onItemChange(catalogNo)
      {
        //nothing
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["pageLayoutData","xSelectedPlatform","minisite_data","siteDataReady"]),
        componentData()
        {
            return this.getSiteTechTabData();
        },
        ____componentImages()
        {
            //this.componentData
            //filter only relvenet images
            return this.componentData.files;//.filter(x => x.file_url.indexOf(".png")>0);
        },
        getStorePlatform()
        {
          return this.xSelectedPlatform;//
        },
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.componentData;//.platforms[this.plaformIndex].items;
            //return this.minisite_data.SECTIONS[this.sectionDataIndex];
        },
        platformItems()
        {
            return this.componentData.platforms[this.plaformIndex].items;
            return this.minisite_data.SECTIONS[this.sectionDataIndex].platforms[this.plaformIndex].items;//.platforms[this.plaformIndex].items;
            //return this.sectionData.platforms[this.plaformIndex].items;
        }        

    }
};

</script>


<style>
    @property --c {
      syntax: '<color>';
      inherits: false;
      initial-value: red;
    }
    .dimProcCont2
    {
      width: 100%;
      text-align: center;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.5s;
      background: transparent;
      position: relative;
    }
    .dimProcCont2.imgFadeout
    {
      opacity: 0;
    }
    .dimItemImg
    {
      width: auto;height:30vw;padding-top: 1vw;
    }    
    .techDim2
    {
        background: transparent;
        width: 100%;
        height: 100%;   
        position: relative;     
        display: block;
    }    
    .techDim2.visible
    {
      display: block;
    }
    .techDim2.platform_0{--c:#2a2512;}
    .techDim2.platform_1{--c:#241128;}
    .techDim2.platform_2{--c:#241128;}
    .techDim2.platform_3{--c:#0f250e;}

    .techDim2 .container
    {
      width: 100vw;
    }
    .techDim2 .info
    {
        position:absolute;
        left: 0px;
        top: 20vh;
        opacity: 1;
        padding-left: 5vw;
        /* padding-left: calc(24vw / 2); */
    }
    .techDim2 .info.infoFadeout
    {
      opacity: 0;
    }

    .techDim2 .info .infItem:nth-child(1)
    {
      font-weight: bold;
    }
    .techDim2 .info .infItem
    {
      padding-top: 3px;
      font-size: 18px;
      text-align: left;        
      color: #202020;
    }


    .techDim2 .infPlatformBarContainer
    {
      position: absolute;
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      /* position: absolute;bottom: 30px; */
      width: 100%;
    }
    .techDim2 .infPlatformBarContainer.mounted
    {
      /* top:calc(100vh - 120px); */
      bottom: 10px;
    }    

    .techDim2 .imgContainer
    {
      /* position: absolute;top:43%;transform: translateY(-50%); */
      padding-top: 30px;
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.8s;
    }
    .techDim2 .imgContainer.techImgFadeout
    {
      opacity: 0;
    }
    .techDim2 .imgContainer .itemImg
    {
      height: 26vw;width: auto;
    }
    .techDim2 .imgContainer .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #fff;font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    .techDim2
    {      
      min-height: 30vh;
      width: 100% !important;
      height: auto;
      display: block;
      margin-bottom: 100px;      
    }    
    .techDim2 .title
    {
      position: initial;
      padding-top: 100px;
      padding-left: 10vw;
      text-align: left;
    }    
    .techDim2 .info
    {
        position:initial;
        padding-top: 30px;
        transform: none;
        padding-left: 10vw;
    }    
    .techDim2 .imgContainer
    {
        position: initial;
        transform:none;
        padding-top: 40px;
    }
    .techDim2 .infPlatformBarContainer
    {
      position: static;
      transform: translateY(0%);
      width: 100%;
      /* padding: 50px 0px 50px 0px; */
      padding: 50px 0px 0px 0px;
    }    
    .techDim2 .infPlatformBarContainer.mounted
    {

    }    
    .dimItemImg 
    {
        height: 70vw;
        padding-top: 1vw;
    }    

  }  
</style>